// @flow

import { useEffect, useRef } from 'react';

const deepCompareEquals = (a: any, b: any) => {
  return JSON.stringify(a) === JSON.stringify(b);
};

const useDeepCompareMemoize = (value) => {
  const ref = useRef();

  if (!deepCompareEquals(value, ref.current)) {
    ref.current = value;
  }

  return ref.current;
};

export const useDeepCompareEffect = (
  callback: () => any,
  dependencies: any,
) => {
  useEffect(callback, useDeepCompareMemoize(dependencies));
};
